import { useEffect, useState } from 'react';
import { getOnlineAttConfig, saveOnlineAttConfig, checkinLog, facePending, faceApprove, faceRegistered, faceRequestReregister, presentNow, faceStatus } from '../api/attendance';
import { fmtDateTime, timeAgo } from '../utils/format';
import { getPublicIp } from '../utils/publicIp';
import { vpnIpInfo } from '../utils/vpnIp';

// Cấu hình chấm công online + nhật ký check-in (Giám đốc/Cố vấn).
export default function OnlineAttAdminModal({ onClose, toast }) {
  const [cfg, setCfg] = useState(null);
  const [ipText, setIpText] = useState('');
  const [busy, setBusy] = useState(false);
  const [month, setMonth] = useState(new Date().toISOString().slice(0, 7));
  const [log, setLog] = useState([]);
  const [pending, setPending] = useState([]);
  const [registered, setRegistered] = useState([]); // TẤT CẢ NV + trạng thái đăng ký khuôn mặt
  const [regStat, setRegStat] = useState({ total: 0, registeredCount: 0, approvedCount: 0 });
  const [showReg, setShowReg] = useState(false);
  const [regFilter, setRegFilter] = useState('all'); // all | none (chưa đăng ký) | wait (chờ duyệt) | ok (đã duyệt)
  const [regBusy, setRegBusy] = useState('');

  useEffect(() => {
    getOnlineAttConfig().then((c) => { setCfg(c); setIpText((c.allowedIps || []).join('\n')); }).catch(() => {});
  }, []);
  useEffect(() => { checkinLog({ month }).then((d) => setLog(d.items || [])).catch(() => {}); }, [month]);
  const loadPending = () => facePending().then((d) => setPending(d.items || [])).catch(() => {});
  const loadRegistered = () => faceRegistered().then((d) => { setRegistered(d.items || []); setRegStat({ total: d.total || 0, registeredCount: d.registeredCount || 0, approvedCount: d.approvedCount || 0 }); }).catch(() => {});
  // GĐ yêu cầu 1 NV đăng ký lại: xoá khuôn mặt hiện tại + gửi thông báo cho NV đó.
  async function askReregister(r) {
    const reason = window.prompt(`Yêu cầu ${r.name} đăng ký lại khuôn mặt?\n\nKhuôn mặt hiện tại sẽ bị XOÁ và nhân viên phải đăng ký lại (chờ Giám đốc duyệt).\nNhập lý do (không bắt buộc):`, '');
    if (reason === null) return;
    setRegBusy(r.id);
    try {
      await faceRequestReregister(r.id, reason);
      toast(`📸 Đã yêu cầu ${r.name} đăng ký lại khuôn mặt`);
      loadRegistered(); loadPending();
    } catch (e) { toast(e?.response?.data?.message || 'Không gửi được yêu cầu', 'danger'); }
    finally { setRegBusy(''); }
  }
  useEffect(() => { loadPending(); loadRegistered(); }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const [myIp, setMyIp] = useState('');
  const [showHelp, setShowHelp] = useState(false);
  // Ưu tiên IP public client tự lấy (đúng IP internet văn phòng, chạy được cả khi dev/local thấy 127.0.0.1);
  // nếu không lấy được thì mới dùng IP server nhận.
  useEffect(() => { getPublicIp().then((ip) => faceStatus(ip).then((s) => setMyIp(ip || s.ip || '')).catch(() => setMyIp(ip || ''))); }, []);
  const addIp = (val) => setIpText((t) => {
    const lines = t.split('\n').map((s) => s.trim()).filter(Boolean);
    if (lines.includes(val)) return t;
    return [...lines, val].join('\n');
  });

  const [present, setPresent] = useState([]);
  useEffect(() => {
    const load = () => presentNow().then((d) => setPresent(d.items || [])).catch(() => {});
    load();
    const t = setInterval(load, 60000);
    return () => clearInterval(t);
  }, []);

  async function decide(id, action) {
    try { await faceApprove(id, action); toast(action === 'approve' ? 'Đã duyệt khuôn mặt' : 'Đã từ chối'); loadPending(); }
    catch (e) { toast(e.response?.data?.message || 'Lỗi', 'danger'); }
  }

  async function save() {
    setBusy(true);
    try {
      const allowedIps = ipText.split('\n').map((s) => s.trim()).filter(Boolean);
      await saveOnlineAttConfig({ ...cfg, allowedIps });
      toast('Đã lưu cấu hình chấm công online');
    } catch (e) { toast(e.response?.data?.message || 'Lưu thất bại', 'danger'); }
    finally { setBusy(false); }
  }

  if (!cfg) return <div><span className="close" onClick={onClose}>×</span><div className="empty">Đang tải…</div></div>;
  const set = (k, v) => setCfg((c) => ({ ...c, [k]: v }));

  return (
    <div style={{ maxWidth: 640 }}>
      <span className="close" onClick={onClose}>×</span>
      <h3 style={{ marginTop: 0 }}>⚙️ Chấm công online — cấu hình & nhật ký</h3>

      <div style={{ marginBottom: 14 }}>
        <b>Khuôn mặt chờ duyệt {pending.length ? `(${pending.length})` : ''}</b>
        {pending.length ? (
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(150px, 1fr))', gap: 10, marginTop: 8 }}>
            {pending.map((p) => (
              <div key={p.id} className="card" style={{ padding: 8 }}>
                {p.photo
                  ? <img src={p.photo} alt={p.name} style={{ width: '100%', borderRadius: 8, aspectRatio: '4/3', objectFit: 'cover' }} />
                  : <div className="empty" style={{ aspectRatio: '4/3', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>Không có ảnh</div>}
                <div style={{ fontWeight: 600, fontSize: 13, marginTop: 6 }}>{p.name}</div>
                <div className="small muted">{p.employeeCode || ''} · {fmtDateTime(p.registeredAt)}</div>
                <div className="row" style={{ gap: 6, marginTop: 8 }}>
                  <button className="btn sm" style={{ flex: 1 }} onClick={() => decide(p.id, 'approve')}>✓ Duyệt</button>
                  <button className="btn sm ghost danger" onClick={() => decide(p.id, 'reject')}>✕</button>
                </div>
              </div>
            ))}
          </div>
        ) : <div className="small muted" style={{ marginTop: 4 }}>Không có yêu cầu nào.</div>}
      </div>

      {/* DANH SÁCH KIỂM SOÁT khuôn mặt: ai ĐÃ / CHƯA đăng ký + độ phủ. NV không tự đăng ký lại được
          (tránh đăng ký đè) -> Giám đốc mở khoá bằng nút "Yêu cầu đăng ký lại" tại đây. */}
      {(() => {
        const notReg = regStat.total - regStat.registeredCount;
        const waiting = regStat.registeredCount - regStat.approvedCount;
        const shown = registered.filter((r) =>
          regFilter === 'none' ? !r.registered
          : regFilter === 'wait' ? (r.registered && !r.approved)
          : regFilter === 'ok' ? r.approved : true);
        const TABS = [
          ['all', `Tất cả (${regStat.total})`],
          ['none', `Chưa đăng ký (${notReg})`],
          ['wait', `Chờ duyệt (${waiting})`],
          ['ok', `Đã duyệt (${regStat.approvedCount})`],
        ];
        return (
          <div style={{ marginBottom: 14 }}>
            <div className="row between" style={{ alignItems: 'center', flexWrap: 'wrap', gap: 8 }}>
              <b>📋 Đăng ký khuôn mặt — {regStat.approvedCount}/{regStat.total} nhân viên đã dùng được
                {notReg > 0 && <span style={{ color: 'var(--danger)', fontWeight: 600 }}> · còn {notReg} người chưa đăng ký</span>}
              </b>
              <button className="btn ghost sm" onClick={() => setShowReg((v) => !v)}>{showReg ? '▲ Thu gọn' : '▼ Mở danh sách'}</button>
            </div>
            {showReg && (
              <>
                <div className="seg" style={{ margin: '8px 0' }}>
                  {TABS.map(([k, lb]) => (
                    <button key={k} className={regFilter === k ? 'active' : ''} onClick={() => setRegFilter(k)}>{lb}</button>
                  ))}
                </div>
                {shown.length ? (
                  <div className="tbl-wrap framed" style={{ maxHeight: 280, overflowY: 'auto' }}>
                    <table style={{ fontSize: 13 }}>
                      <thead><tr><th>Nhân viên</th><th>Phòng ban</th><th>Đăng ký lúc</th><th className="c">Trạng thái</th><th className="c">Thao tác</th></tr></thead>
                      <tbody>
                        {shown.map((r) => (
                          <tr key={r.id}>
                            <td>{r.name} <span className="small muted">{r.employeeCode || ''}</span></td>
                            <td className="small muted">{r.dept}{r.team ? ` · ${r.team}` : ''}</td>
                            <td className="small muted">{r.registered ? fmtDateTime(r.registeredAt) : '—'}</td>
                            <td className="c">
                              {!r.registered ? <span className="small" style={{ color: 'var(--danger)' }}>✕ Chưa đăng ký</span>
                                : r.approved ? <span className="small" style={{ color: 'var(--ok)' }}>✓ Đã duyệt</span>
                                : <span className="small" style={{ color: 'var(--warn)' }}>⏳ Chờ duyệt</span>}
                            </td>
                            <td className="c">
                              {r.registered ? (
                                <button className="btn sm ghost" disabled={regBusy === r.id} onClick={() => askReregister(r)}
                                  title="Xoá khuôn mặt hiện tại & yêu cầu nhân viên đăng ký lại">
                                  {regBusy === r.id ? 'Đang gửi…' : '📸 Yêu cầu đăng ký lại'}
                                </button>
                              ) : <span className="small muted">—</span>}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                ) : <div className="small muted" style={{ marginTop: 4 }}>Không có ai trong mục này.</div>}
              </>
            )}
          </div>
        );
      })()}

      {(() => {
        const online = present.filter((p) => p.online);
        const atCo = online.filter((p) => p.atCompany).length;
        return (
          <div style={{ marginBottom: 14 }}>
            <b>Đang ở công ty (theo Wifi/IP) — {atCo}/{online.length} online</b>
            {online.length ? (
              <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6, marginTop: 8 }}>
                {[...online].sort((a, b) => (b.atCompany ? 1 : 0) - (a.atCompany ? 1 : 0)).map((p) => (
                  <span key={p.id} title={`${p.ip} · ping ${timeAgo(p.at)}`} style={{ display: 'inline-flex', alignItems: 'center', gap: 5, padding: '3px 10px', borderRadius: 999, fontSize: 12, fontWeight: 600,
                    background: p.atCompany ? 'color-mix(in srgb, var(--ok) 15%, transparent)' : 'color-mix(in srgb, var(--warn-fill) 15%, transparent)',
                    color: p.atCompany ? 'var(--ok)' : 'var(--warn)' }}>
                    {p.atCompany ? '🟢' : '🟡'} {p.name}
                  </span>
                ))}
              </div>
            ) : <div className="small muted" style={{ marginTop: 4 }}>Chưa có ai đang mở app. (Cần đã cấu hình dải IP công ty bên dưới để nhận biết "ở công ty".)</div>}
          </div>
        );
      })()}

      <div className="card" style={{ background: 'var(--panel2)', marginBottom: 14 }}>
        <label className="row" style={{ gap: 8, alignItems: 'center', marginBottom: 8 }}>
          <input type="checkbox" style={{ width: 'auto' }} checked={cfg.ipCheckEnabled} onChange={(e) => set('ipCheckEnabled', e.target.checked)} />
          <span>Chỉ cho chấm công trong mạng Wifi công ty (theo IP)</span>
        </label>
        <div className="field" style={{ marginBottom: 8 }}>
          <label className="small muted">IP/dải IP công ty cho phép (mỗi dòng 1 mục — khớp theo tiền tố, vd <code>113.161.</code>)</label>
          <textarea rows={3} value={ipText} onChange={(e) => setIpText(e.target.value)} placeholder="vd: 113.161.10.5 hoặc tiền tố 113.161." disabled={!cfg.ipCheckEnabled} />
          {myIp && (() => {
            const v = vpnIpInfo(myIp);
            // Bấm thêm khi IP là VPN -> bắt xác nhận, tránh khai nhầm IP dùng chung toàn cầu.
            const guardAdd = (val) => {
              if (v.vpn && !window.confirm(`⚠️ ${myIp} là IP của ${v.provider} — KHÔNG phải mạng công ty.\n\n${v.why}\n\nVẫn thêm?`)) return;
              addIp(val);
            };
            return (
              <>
                <div className="small" style={{ marginTop: 6, display: 'flex', gap: 8, alignItems: 'center', flexWrap: 'wrap' }}>
                  <span className="muted">IP internet bạn đang dùng:</span>
                  <code style={{ color: v.vpn ? 'var(--danger)' : 'var(--accent)' }}>{myIp}</code>
                  <button className="btn ghost sm" type="button" onClick={() => guardAdd(myIp)}>＋ Thêm đúng IP này</button>
                  {myIp.includes('.') && <button className="btn ghost sm" type="button" onClick={() => guardAdd(myIp.split('.').slice(0, 3).join('.') + '.')} title="Bao cả dải nếu IP nhà mạng đổi octet cuối">＋ Thêm dải {myIp.split('.').slice(0, 3).join('.')}.</button>}
                </div>
                {v.vpn && (
                  <div className="small" style={{ marginTop: 6, padding: '9px 11px', borderRadius: 8, lineHeight: 1.55,
                    background: 'color-mix(in srgb, var(--danger) 10%, transparent)', border: '1px solid color-mix(in srgb, var(--danger) 40%, transparent)' }}>
                    <b style={{ color: 'var(--danger)' }}>⚠️ IP này là VPN ({v.provider}) — không phải mạng công ty. ĐỪNG thêm.</b>
                    <div style={{ marginTop: 4 }}>{v.why}</div>
                    <div style={{ marginTop: 4 }}>👉 Hãy <b>tắt VPN/WARP</b> rồi mở lại màn này để đọc đúng IP văn phòng.</div>
                  </div>
                )}
              </>
            );
          })()}
          {/* Cảnh báo các dòng ĐÃ KHAI là IP VPN (vd trót thêm khi đang bật WARP). */}
          {(() => {
            const bad = ipText.split('\n').map((s) => s.trim()).filter(Boolean)
              .map((line) => ({ line, v: vpnIpInfo(line.replace(/\.$/, '.0')) }))
              .filter((x) => x.v.vpn);
            if (!bad.length) return null;
            return (
              <div className="small" style={{ marginTop: 8, padding: '9px 11px', borderRadius: 8, lineHeight: 1.55,
                background: 'color-mix(in srgb, var(--danger) 10%, transparent)', border: '1px solid color-mix(in srgb, var(--danger) 40%, transparent)' }}>
                <b style={{ color: 'var(--danger)' }}>⚠️ Danh sách đang có {bad.length} mục là IP VPN — nên XOÁ:</b>
                <div style={{ marginTop: 4 }}>{bad.map((x) => <code key={x.line} style={{ marginRight: 8, color: 'var(--danger)' }}>{x.line}</code>)}</div>
                <div style={{ marginTop: 4 }}>Đây là IP {bad[0].v.provider} dùng chung toàn cầu → <b>bất kỳ ai bật VPN cũng chấm công được</b>.</div>
                <button type="button" className="btn sm ghost" style={{ marginTop: 6 }}
                  onClick={() => setIpText(ipText.split('\n').filter((l) => !vpnIpInfo(l.trim().replace(/\.$/, '.0')).vpn).join('\n'))}>
                  🗑 Xoá các dòng VPN
                </button>
              </div>
            );
          })()}
          <button type="button" className="btn ghost sm" style={{ marginTop: 8 }} onClick={() => setShowHelp((v) => !v)}>
            {showHelp ? '▾' : '▸'} Cách lấy dải IP Wifi công ty
          </button>
          {showHelp && (
            <div className="small" style={{ marginTop: 8, padding: '10px 12px', background: 'color-mix(in srgb, var(--accent) 8%, transparent)', border: '1px solid var(--border)', borderRadius: 8, lineHeight: 1.6 }}>
              <div><b>Cần điền IP public của đường internet công ty</b> (cái server nhìn thấy), KHÔNG dùng IP nội bộ <code>192.168.x.x</code> / <code>10.x.x.x</code> (mọi Wifi đều giống nhau → vô nghĩa).</div>
              <div style={{ marginTop: 6 }}><b>Cách nhanh nhất:</b> mở app trên máy <b>đang nối Wifi công ty</b> → bấm <b>＋ Thêm IP này</b> (hoặc ＋ Thêm dải) ở trên.</div>
              <div style={{ marginTop: 6 }}><b>Cách thủ công:</b> ở máy trong Wifi công ty, tra Google <i>"what is my ip"</i> hoặc <code>whatismyipaddress.com</code> rồi lấy con số đó.</div>
              <ul style={{ margin: '6px 0 0', paddingLeft: 18 }}>
                <li>IP nhà mạng thường <b>đổi định kỳ</b> → nên nhập theo <b>tiền tố</b> (vd <code>113.161.</code> hoặc <code>113.161.10.</code>) để bao cả dải; hoặc xin ISP cấp <b>IP tĩnh</b>.</li>
                <li>Nhiều đường mạng / chi nhánh → nhập <b>mỗi dòng 1 IP/dải</b>.</li>
                <li>Kiểm tra đúng chưa: người ngồi tại văn phòng phải hiện chip <b>🟢 xanh</b> ở mục "Đang ở công ty" phía trên.</li>
              </ul>
            </div>
          )}
        </div>
        <div className="row" style={{ gap: 16, flexWrap: 'wrap', alignItems: 'center' }}>
          <label className="row" style={{ gap: 8, alignItems: 'center' }}>
            <input type="checkbox" style={{ width: 'auto' }} checked={cfg.livenessRequired} onChange={(e) => set('livenessRequired', e.target.checked)} />
            <span className="small">Bắt buộc nháy mắt (chống ảnh)</span>
          </label>
          <label className="row" style={{ gap: 6, alignItems: 'center' }}>
            <span className="small muted">Ngưỡng khớp mặt</span>
            <input type="number" step="0.05" min="0.3" max="0.8" value={cfg.matchThreshold} onChange={(e) => set('matchThreshold', Number(e.target.value))} style={{ width: 80 }} />
            <span className="small muted" title="Càng nhỏ càng chặt (khó khớp nhầm). Mặc định 0.5">?</span>
          </label>
          <div className="spacer" />
          <button className="btn" disabled={busy} onClick={save}>Lưu cấu hình</button>
        </div>
      </div>

      <div className="row between" style={{ alignItems: 'center', marginBottom: 6 }}>
        <b>Nhật ký chấm công</b>
        <input type="month" value={month} onChange={(e) => setMonth(e.target.value)} style={{ width: 'auto' }} />
      </div>
      <div style={{ maxHeight: 300, overflow: 'auto' }}>
        <table style={{ fontSize: 12.5, width: '100%' }}>
          <thead><tr>
            <th>Thời điểm</th><th>Nhân viên</th><th>Loại</th><th className="c">Khớp</th><th className="c">Sống</th><th className="c">IP</th>
          </tr></thead>
          <tbody>
            {log.length ? log.map((c) => (
              <tr key={c.id}>
                <td className="small">{fmtDateTime(c.at)}</td>
                <td>{c.name}</td>
                <td>{c.type === 'in' ? 'VÀO' : c.type === 'out' ? 'RA' : '—'}</td>
                <td className="c" style={{ color: c.matched ? 'var(--ok)' : 'var(--danger)', fontWeight: 600 }}>{c.matched ? `✓ ${Number(c.distance).toFixed(2)}` : `✕ ${c.distance != null ? Number(c.distance).toFixed(2) : ''}`}</td>
                <td className="c">{c.liveness ? '👁' : '—'}</td>
                <td className="c small" style={{ color: c.ipOk ? 'inherit' : 'var(--danger)' }} title={c.ip}>{c.ipOk ? 'OK' : '⚠'}</td>
              </tr>
            )) : <tr><td colSpan={6} className="empty">Chưa có lượt chấm nào.</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
